import { Stack, Typography } from '@mui/material';
import { SUPPLIER_LEVEL_BINDING } from '@retail/calculus/utils';
import { LevelChip } from '../ConditionApproval';

interface Props {
  supplierName: string;
  conditionInDraft: boolean;
}

export const SupplierLevelAndNameCell = ({ supplierName, conditionInDraft }: Props) => (
  <Stack direction="row" gap={2}>
    <LevelChip
      bindingType={SUPPLIER_LEVEL_BINDING}
      active={!conditionInDraft}
      variant="fixed"
      size="small"
      abbreviation
    />
    <Typography variant="subtitle2" component="span">
      {supplierName}
    </Typography>
  </Stack>
);
